import { BqDrawer, BqDivider } from '@beeq/react'
import styled from 'styled-components'

export const StyledBqDrawer = styled(BqDrawer)`
  --bq-drawer--width: 450px;
  --bq-drawer--paddingX: var(--bq-spacing-xl);
  --bq-drawer--paddingY: var(--bq-spacing-xl);

  &::part(backdrop){
    z-index: 1;
  }

  &::part(body) {
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
`

export const StyledBqDrawerContent = styled.main`
  display: flex;
  flex-direction: column;
  gap: var(--bq-spacing-l);
  height: 100%;
  overflow: hidden;
`

export const StyledFieldsWrapper = styled.div`
  overflow: auto;
  padding-right: 20px;
`

export const StyledBqDrawerSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--bq-spacing-m);
`

export const StyledFooter = styled.footer`
  display: flex;
  gap: var(--bq-spacing-xs)
`

export const StyledBqDivider = styled(BqDivider)`
  &::part(base){
    margin-bottom: var(--bq-spacing-m);
  }
`
